import { useLocation, useNavigate, Link } from "react-router-dom";
import { COMPANY, NAV_LINKS } from "@/lib/site-data";

export const Footer = () => {
  const year = new Date().getFullYear();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isHome = pathname === "/";

  const goSection = (id) => {
    if (isHome) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-950 text-slate-300 border-t border-white/10"
    >
      <div className="container-narrow py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-serif text-3xl text-white tracking-tight">
              Dream<span className="text-emerald-400">Axis</span>
            </div>
            <div className="overline text-slate-500 mt-2">
              {COMPANY.legalName}
            </div>
            <p className="mt-6 text-sm leading-relaxed text-slate-400 max-w-md">
              Business and programme management for ambitious organisations
              across Europe and worldwide. Three sectors. One discipline.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-slate-500 mb-4">Navigate</div>
            <ul className="space-y-2 text-sm">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => goSection(l.id)}
                    className="hover:text-white transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline text-slate-500 mb-4">Contact</div>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  data-testid="footer-email"
                  href={`mailto:${COMPANY.email}`}
                  className="hover:text-white transition-colors break-all"
                >
                  {COMPANY.email}
                </a>
              </li>
              <li>{COMPANY.hqAddress}</li>
              <li className="font-mono text-xs text-slate-500 pt-2">
                REGON / NIP · {COMPANY.regon}
              </li>
            </ul>
          </div>
        </div>

        <div className="rule-dark mt-14" />

        <div className="pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-slate-500">
          <div>
            © {year} {COMPANY.legalName}. All rights reserved. ·{" "}
            <span className="text-slate-400">{COMPANY.domain}</span>
          </div>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            <Link
              data-testid="footer-legal-terms"
              to="/legal/terms"
              className="hover:text-white transition-colors"
            >
              Terms of Service
            </Link>
            <Link
              data-testid="footer-legal-privacy"
              to="/legal/privacy"
              className="hover:text-white transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              data-testid="footer-legal-refunds"
              to="/legal/refunds"
              className="hover:text-white transition-colors"
            >
              Refund Policy
            </Link>
            <Link
              data-testid="footer-legal-disclosures"
              to="/legal/disclosures"
              className="hover:text-white transition-colors"
            >
              Disclosures & Disclaimers
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
